function StoreRibbonsInCookie(theRibbons) {
    var length = theRibbons.length;
    var ribbonList = [];

    for (var i = 0; i < length; i++) {
        var dataItem = theRibbons[i];

        var newsAlert = {
            updatedAt: dataItem.updatedAt,
            Uid: dataItem.Uid,
        }
        ribbonList.push(newsAlert);
    }
    $.cookie('ribbonCookie', JSON.stringify(ribbonList), { path: '/;SameSite=Lax', secure: true });
}

function HeaderScroll(scrolled) {
    var $banner = $('[role=banner]');
    var $body = $('body');
    if (window.matchMedia('(min-width: 750px)').matches) {
        var scrollt = window.scrollY;
        var height = $banner.outerHeight();

        //if iPhone remove added margin
        if (navigator.platform.indexOf('iPhone') != -1 ||
            navigator.platform.indexOf('iPod') != -1) {
            $body.removeClass('marginTop-none');
        }

        var $datepickerDiv = $('#ui-datepicker-div');
        if (scrollt > 0) {
            $body.css('margin-top', height + 'px');
            if (!$banner.hasClass('is-fixed')) {
                $banner.addClass('is-fixed');
            }

            if (scrolled && $datepickerDiv.is(':visible')) {
                if ($datepickerDiv.attr('data-header-fixed') === 'true') {
                    $datepickerDiv.css('margin-top', '');
                } else {
                    $datepickerDiv.css('margin-top', -height + 'px');
                }
            }
        } else {
            $body.css('margin-top', '0');
            if ($banner.hasClass('is-fixed')) {
                $banner.removeClass('is-fixed');
            }

            if (scrolled && $datepickerDiv.is(':visible')) {
                if ($datepickerDiv.attr('data-header-fixed') === 'true') {
                    $datepickerDiv.css('margin-top', height + 'px');
                } else {
                    $datepickerDiv.css('margin-top', '');
                }
            }
        }
    } else {
        $banner.removeClass('is-fixed');
        $body.css('margin-top', '0');
    }
}

function removeFlight() {
    $.removeCookie('userSavedFlight', { path: '/;SameSite=Lax', secure: true });
    $('.header-flight').removeClass('fadeInUp');
    $('.header-flight').addClass('animated slideOutRight');
    $('.toggle').fadeIn();
    $('.buttonHtml').html('<a class="btn flightSave" onclick="saveFlight();">Save Flight <i class="fa fa-angle-right"></i></a>');
    $('.saveflight').html('Save flight <i class="fa fa-angle-right"></i>');
    $('.flightSave').html('Save Flight <i class="fa fa-angle-right"></i>');
    $('.header-flight-placeholder').delay(600).animate({ height: '0px' },
        function() {
            $('.header-flight-placeholder').hide();
            $('.header-flight-placeholder').css('height', '');
            $('.header-flight').removeClass('animated slideOutRight');
        });
}

function removeABFlight() {
    $.removeCookie('userSavedFlight', { path: '/;SameSite=Lax', secure: true });
    $('.ab-header-flight').removeClass('fadeInUp');
    $('.ab-header-flight').addClass('animated slideOutRight');
    $('.toggle').fadeIn();
    $('.buttonHtml').html('<a class="btn flightSave" onclick="saveFlight();">Save Flight</a>');
    $('.saveflight').html('Save flight');
    $('.ab-flightSave').removeClass('active');
    $('.ab-flightSave').html('Save Flight');
    $('.ab-header-flight-placeholder').delay(600).animate({ height: '0px' },
        function () {
            $('.ab-header-flight-placeholder').hide();
            $('.ab-header-flight-placeholder').css('height', '');
            $('.ab-header-flight').removeClass('animated slideOutRight');
        });
    $('.ab-header-flight-placeholder.fixed').remove();
}

function ShowFlightSavedMessage() {
    if ($(window).width() <= 550) {
        notif({
            msg: 'Flight Information is pinned &#9650;',
            type: 'info',
            position: 'center',
            timeout: 3000,
        });
    }
}

function StickyFooter() {
    var form = $('.site-wrapper');
    var footer = $('.site-footer');

    if (form.height() < document.body.offsetHeight) {
        footer.addClass('sticky-footer');
    } else {
        footer.removeClass('sticky-footer');
    }
}

$(document).on('click', function () {
    $('#ui_notifIt').on('click', function() {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
    });
});

function WizardScroll(elementClass, additionalOffSet) {
    var $el = $(elementClass);
    if ($el.length > 0) {
        if ($(window).width() <= 550) {
            $('html,body').animate({
                scrollTop: $(elementClass).offset().top - additionalOffSet
            }, 1200);
        } else {
            var height = $('header').height();
            $('html,body').animate({
                scrollTop: $(elementClass).offset().top - (height + additionalOffSet)
            }, 1200);
        }
    }
}

function FlightSearchDropdownHeightSet() {
    var parkingRibbon = $('.parking-ribbon:not(.no-flight-search)');

    if (parkingRibbon.length) {
        var heightDifference = $('.parking-ribbon').offset().top - $('.flight-search--field input').offset().top;
        $('.flight-search .results').css('max-height', heightDifference + 43);
    }
}

var bannerImageUrl = '';
var corporateHeaderUrl = '';
var videoBannerExists;
var windowWidth;

$(window).on('resize orientationchange load', function () {
    if (videoBannerExists) {
        if ($(window).width() > 1150) {
            $('.banner-holder').css('background-image', '');
            $('.corporate-headerwrapper').css('background-image', '');
        } else {
            $('.banner-holder').css('background-image', bannerImageUrl);
            $('.corporate-headerwrapper').css('background-image', corporateHeaderUrl);
        }
    }
    $('.home--banner').removeClass('invisible');
    FlightSearchDropdownHeightSet();

    if (windowWidth !== window.innerWidth) {
	    salvattore.rescanMediaQueries();
	    windowWidth = window.innerWidth;
    }
});

function resizedw() {
    FlightSearchDropdownHeightSet();
}

$(window).on('scroll', function () {
    FlightSearchDropdownHeightSet();
});

$(document).ready(function () {
    var doit;
    var cardAppenders = $(".js-appendequalheightclasstowwrapper");
    cardAppenders.each(function () {
        var nearestWrapper = $(this).closest('.wrapper'); 
        if (nearestWrapper.length && !nearestWrapper.hasClass('match-height--cards')) { 
            nearestWrapper.addClass('match-height--cards'); 
        }
    });

    equalHeightTestimonials(false);
    equalHeightExecBoxes(false);

    window.onresize = function () {
        clearTimeout(doit);
        doit = setTimeout(resizedw, 100);
        equalHeightTestimonials(true);
        equalHeightExecBoxes(true);
    };

    FlightSearchDropdownHeightSet();

    videoBannerExists = $('.video-banner').length;

    // hacky device detection
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
        || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
        if (videoBannerExists) {
            $('.video-banner').hide();
        }
    }

    if (videoBannerExists) {
        bannerImageUrl = $('.banner-holder').css('background-image');
        corporateHeaderUrl = $('.corporate-headerwrapper').css('background-image');
        $('.banner-holder').css('background-image', '');
        $('.corporate-headerwrapper').css('background-image', '');
    }

    $('.fa-angle-up, .fa-angle-down').on('click', function() {
        $(this).next('input').focus();
    });
    
    var form = $('.site-wrapper');

    if (form.height() < document.body.offsetHeight) {
        var footer = $('.site-footer');
        footer.addClass('sticky-footer');
    }

    //Remove border on hover but ensures the page doesn't move
    $('.card--actions a, .news-list a').hover(function () {
        $(this).closest('.borderbtm').css('border-bottom', '1px solid transparent');
    }, function () {
        $(this).closest('.borderbtm').css('border-bottom', '1px solid rgba(0,0,0,.1)');
    });

    //adding class' on cards external links for tag manager
    $('.card--actions a[href*="http://"]').each(function () {
        $(this).addClass('gaExternalLink');
    });

    //anchor fix to the correct position
    $('a[href*="#"]').each(function () {
        var $this = $(this);

        if ($this.attr('href') === '#top')     
        {
            $this.on('click', function () {
                let $banner = $('[role=banner]');
                let $body = $('body');
                $banner.removeClass('is-fixed');
                $body.css('margin-top', '0');
                setTimeout(() => {
                    window.scrollTo({
                        top: 0
                    });
                }, 0);

            });
        }
        else if (!$this.hasClass('noscrollfix') && !$("body").hasClass("design-b")) {
            $this.addClass('addheadpadding');
        }
    });

    $('.addheadpadding').on('click', function () {
        $('body,html').animate({ top: '250' });
    });

    $('img:not([src]):not([data-src]), img[src=""]:not([data-src])').hide();

    $('#expand').on('click', function () {
        $('.flight-card--journey').animate({ height: '320' });
    });

    $('.header-alert--close').on('click', function () {
        $('.header-alert:not(.cookie-bar)').animate({ height: '0px', padding: '0px' }, function _afterAnimation() {
            $('.header-alert:not(.cookie-bar)').remove();
            $.cookie('showRibbonCookie', 'false', { path: '/;SameSite=Lax', secure: true});
        });
    });

    $('.cookie-bar--close').on('click', function () {
        $('.cookie-bar').animate({ height: '0px', padding: '0px' }, function _afterAnimation() {
            $('.cookie-bar').remove();
            $.cookie('showCookieBarCookie', 'false', { expires: 365, path: '/;SameSite=Lax', secure: true });
        });
    });

    $('.flights ul.flight-tabs li').on('click', function () {
        var tab_id = $(this).attr('data-tab');

        $('.flights ul.flight-tabs li').removeClass('current');
        $('.flights .flight-tab--content').removeClass('current');

        $(this).addClass('current');
        $('.flights #' + tab_id).addClass('current');
    });
});

$(document).on('click', function () {
    HeaderScroll(false);
    StickyFooter();
});

$(window).on('scroll', function () {
    HeaderScroll(true);
    $('body,html').css('top', '0px');
    StickyFooter();
});

$(window).on('load', function () {
    HeaderScroll(false);
    StickyFooter();
    ABTestScripts();
});

function ABTestScripts() {
    // Homepage version 1
    if ($(".homepage-a").length) {
        
    }
}

function getUrlVars() {
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}

$(function () {
    $('.faq-accordian__qna__question').on('click', function () {
        $(this).toggleClass('active');
        $(this).siblings('.faq-accordian__qna__answer').slideToggle();
    });

    $('.twentytwenty-container').twentytwenty();
});

function equalHeightExecBoxes(isResize) {
    var items = $('.execlounge-grid').find('.execlounge-grid--item');

    var maxHeight = 0;
    items.each(function () {
        if (isResize)
            $(this).css('min-height', 'initial');
        maxHeight = maxHeight > $(this).height() ? maxHeight : $(this).height();
    });

    items.each(function () {
        $(this).css('min-height', maxHeight + (parseInt($(this).css('padding')) * 2));
    });
}
 

function equalHeightTestimonials(isResize) {
    var cards = $('.match-height--cards').find('.card .card--content');
    var authors = $('.match-height--cards').find('.card .card--content_author');
    
    var maxHeight = 0;
    var authorMaxHeight = 0;

    cards.each(function () {
        if (isResize)
            $(this).css('min-height', 'initial');
        maxHeight = maxHeight > $(this).height() ? maxHeight : $(this).height();
    });

    authors.each(function () {
        if (isResize)
            $(this).css('min-height', 'initial');
        authorMaxHeight = authorMaxHeight > $(this).height() ? authorMaxHeight : $(this).height();
    });

    cards.each(function () {
        $(this).css('min-height', maxHeight + (parseInt($(this).css('padding')) * 2));
    });

    authors.each(function () {
        $(this).css('min-height', authorMaxHeight + (parseInt($(this).css('padding')) * 2));
    });
}

function postForm(path, params, method) {
    method = typeof method === 'undefined' ? 'post' : method;

    const form = document.createElement('form');
    form.method = method;
    form.action = path;

    for (var key in params) {
        if (params.hasOwnProperty(key)) {
            const hiddenField = document.createElement('input');
            hiddenField.type = 'hidden';
            hiddenField.name = key;
            hiddenField.value = params[key];

            form.appendChild(hiddenField);
        }
    }

    document.body.appendChild(form);
    form.submit();
}

$.ajax({
    url: '/api/newsalert',
    type: 'GET',
    contentType: 'application/json; charset=utf-8',
    dataType: 'json',

    success: function (data) {
        if (data != null) {
            if (data.length > 0) {
                startLoop(data);

                var setRibbonCookieValue = $.cookie('ribbonCookie');
                var showRibbonCookie = $.cookie('showRibbonCookie');
                var length = data.length;

                if (setRibbonCookieValue === undefined || showRibbonCookie == undefined) {
                    $('.header-alert:not(.cookie-bar)').show();
                    StoreRibbonsInCookie(data);
                    $.cookie('showRibbonCookie', 'true', { path: '/;SameSite=Lax', secure: true});
                } else {
                    var setRibbonCookie = JSON.parse($.cookie('ribbonCookie'));
                    var setRibbonCookieLength = setRibbonCookie.length;
                    if (length != setRibbonCookieLength) {
                        $('.header-alert:not(.cookie-bar)').show();
                    } else {
                        var hasChanged = false;
                        for (var y = 0; y < setRibbonCookieLength; y++) {
                            var storedRibbonItem = setRibbonCookie[y];
                            var ribbonItem = data[y];
                            if (storedRibbonItem.Uid == ribbonItem.Uid) {
                                if (storedRibbonItem.updatedAt != ribbonItem.updatedAt) {
                                    hasChanged = true;
                                }
                            } else {
                                hasChanged = true;
                            }
                        }

                        if (hasChanged) {
                            $.cookie('showRibbonCookie', 'true', { path: '/;SameSite=Lax', secure: true});
                            $('.header-alert:not(.cookie-bar)').show();
                            StoreRibbonsInCookie(data);
                        } else {
                            var showRibbonCookieValue = $.cookie('showRibbonCookie');

                            if (showRibbonCookieValue == 'false') {
                                $('.header-alert:not(.cookie-bar)').hide();
                            } else {
                                $('.header-alert:not(.cookie-bar)').show();
                            }
                        }
                    }
                }

                updateHeaderHeightVariable();
            }
        }
    }
});

function startLoop(alerts) {
    var currentAlertIndex = 0;
    const searchOverlay = $('.search-overlay');
    $('.header-alert--message a span').eq(0).text(alerts[0].message);
    $('.header-alert--message a').eq(0).attr('href', alerts[0].link);

    if (alerts.length > 1) {
        setInterval(function () {
            $('.header-alert--message').fadeOut(1000, function () {
                currentAlertIndex = (currentAlertIndex < alerts.length - 1) ? currentAlertIndex + 1 : 0;
                $('.header-alert--message a span').eq(0).text(alerts[currentAlertIndex].message);
                $('.header-alert--message a').eq(0).attr('href', alerts[currentAlertIndex].link);
                $('.header-alert--message').fadeIn(1000, function () {
                    if (searchOverlay) {
                        updateHeaderHeightVariable();
                    }
                });
            });
        }, 5000);
    }
}

function updateHeaderHeightVariable() {
    const searchOverlay = $('.search-overlay');

    if (searchOverlay) {
        const root = document.querySelector(':root');
        const headerHeight = $('header').height();
        root.style.setProperty('--header-height', headerHeight + 'px');
    }
}

window.addEventListener('resize', function (event) {
    updateHeaderHeightVariable();
});

/*
 cookie control migration
 */

$(function () {
    var showCookieBarCookie = $.cookie('showCookieBarCookie');
    if (showCookieBarCookie === undefined) {
        $('.cookie-bar').show();
    } else {
        $('.cookie-bar').hide();
    }
});

/*
 flight save migration
 */

//$(function () {
//    $('[data-toggle="popover"]').popover()
//})

$(window).scroll(() => {
  $('.btf-arrow').css('opacity', 1 - $(window).scrollTop() / 300);
});

$(document).ready(function () {

    var formerror = $(".editing-form-control-nested-control.Error");

    if (formerror.length > 0) {
        var headerHeight = $(".header-content").height();
        $("html, body").animate({ scrollTop: $(".editing-form-control-nested-control.Error").offset().top - headerHeight - 40 }, 1000);

    }
  
});

$(document).ready(function () {
    var registrationFormErrors = $('.form__group .form-control-error.field-validation-error');
    if (registrationFormErrors.length > 0) {
        var headerHeight = $(".header-content").height();
        $("html, body").animate({ scrollTop: $(".form__group .form-control-error.field-validation-error").offset().top - headerHeight - 40 }, 1000);
    }
});

$('.card--image .fa-play').on('click', function () {
  $(this).parents('.image-video-cta').find('.card--video-dialog')[0].showModal();
});

$('.card--video-close').on('click', function () {
  $(this).parents('.card--video-dialog')[0].close();
});
